














































































































import Vue from 'vue'
import VideoObject, { VideoObjectConfig } from '../../classes/VideoObject'
import {TranscodingRegion } from '@/types/admin'
import './SelfTest.scss'
import SelfTestSummary from '@/components/SelfTestSummary'
import CameraMicControls from '@/components/CameraMicControls'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import VideoPlayer from '@/components/VideoPlayer'
import AudioPlayer from '@/components/AudioPlayer'
import { Button } from 'element-ui'
import fb from '../../firebase'
import { KeyDict } from '@/types'
import { maybeBoolean, SelfTestStats, UserProfile } from '@/types/users'
import { UnsubscribeFunction } from '@/store/types'

const SELFTEST_DURATION = 30000

// State goes from
// idle -> casting -> reply   -> success
//                            -> fail
//                 -> noreply -> fail

enum SelfTestState {
  IDLE = 'idle',
  CASTING = 'casting',
  REPLY = 'reply',
  NO_REPLY = 'noreply',
  SUCCESS = 'success',
  FAIL = 'fail'
}

export default Vue.extend({
  name: 'SelfTest',
  props: {
    currentUserId: {
      type: String,
      required: true
    },
    transcodingregion: {
      type: String,
      required: true
    }
  },
  data: () => ({
    videoObject: null as VideoObject | null,
    selfVideoObject: null as VideoObject | null,
    isCasting: false,
    streamname: '',
    state: SelfTestState.IDLE,
    lastStateChange: 0,
    nowInterval: null as NodeJS.Timeout | null,
    now: 0,
    unsubscribeFB: null as UnsubscribeFunction | null,
    errormessage: [] as string[],
    selftestResult: {
      hearaudio: null as maybeBoolean,
      seevideo: null as maybeBoolean ,
      hearpreview: null as maybeBoolean,
      seepreview: null as maybeBoolean,
      camerapermission: null as maybeBoolean,
      microphonepermission: null as maybeBoolean,
      network: { 
        download: { 
          bandwidth : 0,
          jitter: 0,
          latency: 0,
          score: 0,
        }, 
        upload: { score: 0 } 
      },
      timestamp : null as number | null,
      region: null as string | null
    } /* ~ SelfTestStats */
  }),
  mounted () : void {
    this.goToState(SelfTestState.IDLE)
    this.streamname = 'selftest_' + Math.random().toString(36).replace(/[^a-z]+/g, '')
    this.nowInterval = setInterval(() => {
      this.now = (new Date()).getTime()
      this.checkEverySecond()
    }, 1000)
  },
  destroyed (): void {
    this.deleteVideoObject()
    this.stopPolling()
    if (this.nowInterval !== null){
      clearInterval(this.nowInterval)
    }
  },
  watch: {
    replyReady (newVal: boolean) : void {
      if (newVal) {
        this.goToState(SelfTestState.REPLY)
        this.startPolling()
      }
    }
  },
  computed: {
    localCameraStream () : MediaStream | null {
      return this.$store.direct.state.events.localCameraStream
    },
    transcodingregions () : KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    userProfile () : UserProfile | null {
      return this.$store.direct.state.user.profile
    },
    wrtcserver (): string {
      let server  = 'wrtc-va1.kiswe.com'
      const region = this.transcodingregions[this.transcodingregion]
      if (region !== undefined) {
        server = Object.values(region.wrtcserver)[0].url
      }
      return server
    },
    duration (): number {
      return SELFTEST_DURATION
    },
    replyReady () : boolean {
      return this.selfVideoObject !== null && this.selfVideoObject.bandwidthcounter > 1
    },
    nextQuestion (): string {
      if (this.selftestResult.seepreview === null) {
        return 'Can you see the preview stream?'
      }
      if (this.selftestResult.hearpreview === null) {
        return 'Can you hear the preview stream?'
      }
      if (this.selftestResult.seevideo === null) {
        return 'Can you see yourself?'
      }
      if (this.selftestResult.hearaudio === null) {
        return 'Can you understand yourself?'
      }
      return ''
    }
  },
  methods: {
    setLocalCameraStream (stream) : void {
      this.$store.direct.dispatch.events.setLocalCameraStream(stream)
    },
    killLocalCameraStream () : void {
      this.$store.direct.dispatch.events.killLocalCameraStream()
    },
    deleteVideoObject () : void {
      if (this.videoObject !== null) {
        this.videoObject.stopPlay()
        this.videoObject = null
      }
      if (this.selfVideoObject !== null) {
        this.selfVideoObject.stopPlay()
        this.selfVideoObject = null
      }
    },
    answer (value: boolean) : void {
      if (this.selftestResult.seepreview === null) {
        this.selftestResult.seepreview = value
      } else if (this.selftestResult.hearpreview === null) {
        this.selftestResult.hearpreview = value
      } else if (this.selftestResult.seevideo === null) {
        this.selftestResult.seevideo = value
      } else if (this.selftestResult.hearaudio === null) {
        this.selftestResult.hearaudio = value
      }
    },
    createVideoObject () : void {
      this.deleteVideoObject()
      const videoId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
      const config : VideoObjectConfig = {
        id: videoId,
        name: videoId, // attribute is needed, but not sure this is the correct value
        streamToPlay: { url: 'rtsp://' + this.wrtcserver + ':1935/livetcp/selftest' },
        logNetwork: true,
        udpEnabled: this.userProfile && this.userProfile.udpEnabled !== undefined ? this.userProfile.udpEnabled : false,
        callback: () => {
          console.log('NEW STREAM')
          // Vue.set(this.streamsManager, id, stream)
        },
        killStream: () => {
          console.log('KILL STREAM')
          this.deleteVideoObject()
          // this.streamsManager[stream.id].stopPlay()
          // this.$delete(this.streamsManager, stream.id)
        },
        restartStream: () => {
          console.log('RESTART STREAM')
          this.createVideoObject()
          // console.log('restartStream', stream)
        }
      }
      this.videoObject = new VideoObject(config)
      this.videoObject.onNetworkStats(this.onNetworkStats)
      const videoId2 = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
      const config2 : VideoObjectConfig = {
        id: videoId2,
        name: videoId2,
        streamToPlay: { url: 'rtsp://' + this.wrtcserver + ':1935/livetcp/' + this.streamname },
        logNetwork: true,
        udpEnabled: this.userProfile && this.userProfile.udpEnabled !== undefined ? this.userProfile.udpEnabled : false,
        callback: () => {
          console.log('NEW STREAM')
          // Vue.set(this.streamsManager, id, stream)
        },
        killStream: () => {
          console.log('KILL STREAM')
          this.deleteVideoObject()
          // this.streamsManager[stream.id].stopPlay()
          // this.$delete(this.streamsManager, stream.id)
        },
        restartStream: () => {
          console.log('RESTART STREAM')
          this.createVideoObject()
          // console.log('restartStream', stream)
        }
      }
      this.selfVideoObject = new VideoObject(config2)
    },
    goToState (newState: SelfTestState) : void {
      this.state = newState
      this.lastStateChange = (new Date()).getTime()
    },
    startStreaming () : void {
      this.isCasting = true
      this.goToState(SelfTestState.CASTING)
      setTimeout(this.createVideoObject, 10000)
    },
    filledIn (): boolean {
      const testResult = this.selftestResult
      let filledIn = this.selftestResult.camerapermission !== null
      filledIn = filledIn && testResult.hearaudio !== null
      filledIn = filledIn && testResult.hearpreview !== null
      filledIn = filledIn && testResult.microphonepermission !== null
      filledIn = filledIn && testResult.seevideo !== null
      filledIn = filledIn && testResult.seepreview !== null
      return filledIn
    },
    checkEverySecond () {
      if (this.state === SelfTestState.CASTING && this.now - this.lastStateChange > SELFTEST_DURATION) {
        this.goToState(SelfTestState.NO_REPLY)
        this.errormessage = ['Could not connect with the echo server, check your network and try again']
      }
      if (this.state === SelfTestState.NO_REPLY && this.now - this.lastStateChange > 10000) {
        this.goToState(SelfTestState.FAIL)
      }
      if (this.state === SelfTestState.REPLY && this.now - this.lastStateChange > SELFTEST_DURATION && this.nextQuestion === '') {
        this.deleteVideoObject()
        if (this.selftestResult.hearaudio &&
            this.selftestResult.seevideo &&
            this.selftestResult.hearpreview &&
            this.selftestResult.seepreview &&
            this.selftestResult.network.upload.score >= 2) {
          this.goToState(SelfTestState.SUCCESS)
        } else {
          this.goToState(SelfTestState.FAIL)
          this.errormessage = []
          if (!this.selftestResult.hearaudio) {
            this.errormessage.push('You were unable to hear yourself well. Please check your computer’s audio settings.')
          }
          if (!this.selftestResult.seevideo) {
            this.errormessage.push('You were unable to see yourself. Please check you camera and try again.')
          }
          if (!this.selftestResult.hearpreview) {
            this.errormessage.push('You were unable to hear the preview well. Check the volume of your headset.')
          }
          if (!this.selftestResult.seepreview) {
            this.errormessage.push('You were unable to see the preview. Please check your network.')
          }
          if (!this.selftestResult.camerapermission) {
            this.errormessage.push('You need to set permissions of your camera')
          }
          if (!this.selftestResult.microphonepermission) {
            this.errormessage.push('You need to set permissions of your microphone')
          }
          if (this.selftestResult.network.upload.score < 4 && this.errormessage.length === 0) {
            this.errormessage.push('The network selftest scored ' + this.selftestResult.network.upload.score + '/5. ' +
            'Please verify your network, use cable instead of wifi if possible, and reduce other network usage on that same network.')
          }
        }
        this.selftestResult.timestamp = Math.floor((new Date()).getTime() / 1000)
        this.selftestResult.region = this.wrtcserver
        const selftest = this.selftestResult as SelfTestStats // TODO assert filledIn
        this.$store.direct.dispatch.user.updateProfile({ id: this.currentUserId, selftest: selftest })
      }
      try {
        navigator.permissions.query({ name: 'camera' }).then(result => {
          this.selftestResult.camerapermission = result.state === 'granted'
        }).catch(error => {
          this.selftestResult.camerapermission = false
          console.error('Could not get camera permissions', error)
        })
        navigator.permissions.query({ name: 'microphone' }).then(result => {
          this.selftestResult.microphonepermission = result.state === 'granted'
        }).catch(error => {
          this.selftestResult.microphonepermission = false
          console.error('Could not get microphone permissions', error)
        })
      } catch (error) {
        console.error('Not able to see permissions of camera or microphone', error)
      }
    },
    stopPolling () : void {
      if (this.unsubscribeFB !== null) {
        this.unsubscribeFB()
        this.unsubscribeFB = null
      }
    },
    startPolling () : void {
      this.stopPolling()
      this.unsubscribeFB = fb.db.collection('networkstats')
                                .doc(this.currentUserId)
                                .onSnapshot(snap => {
        const data = snap.data()
        if(data === undefined){
          throw Error('data is undefined')
        } else {
          this.selftestResult.network.upload = data.upload
          this.selftestResult.network.download.bandwidth = data.download.bandwidth
        }
      }, error => {
        console.error('error startPolling ' + this.currentUserId + ' ' + error)
      })
    },
    onNetworkStats (stats) : void {
      console.log('NEW STATS ARRIVED ', stats)
      this.selftestResult.network.download = {
        bandwidth: this.cleanStats(stats.download),
        jitter: this.cleanStats(stats.jitter),
        latency: this.cleanStats(stats.latency),
        score: this.cleanStats(stats.score)
      }
    },
    cleanStats (stat: number | undefined): number {
      if (stat === undefined) {
        return 0
      }
      return stat
    }
  },
  components: {
    CameraMicControls,
    VideoPlayer,
    AudioPlayer,
    SelfTestSummary,
    'clip-loader': ClipLoader,
    'el-button': Button
  }
})

